import React from 'react';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useTheme from '../../hooks/useTheme';

const Back = () => {
    const { profile } = useSelector((state) => state.profile);
    const theme = useTheme();
    
    return (
        <div className="mb-8 hidden md:block">
            <Link 
                to={`/${profile?.key}`}
                className="inline-flex items-center space-x-2 px-4 py-3 rounded-xl transition-all duration-300 poppins font-medium transform hover:scale-105 border"
                style={{
                    backgroundColor: theme.colors.backButtonBg,
                    color: theme.colors.backButtonText,
                    borderColor: theme.colors.backButtonBorder || 'rgba(0, 0, 0, 0.1)',
                    borderWidth: '1px'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = theme.colors.backButtonHoverBg;
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = theme.colors.backButtonBg;
                }}
            >
                <MdOutlineKeyboardBackspace className="w-5 h-5" />
                <span>Back to Menu</span>
            </Link>
        </div>
    )
}

export default Back
